export default function ConfirmModal({ title, message, confirmText = "Confirm", cancelText = "Cancel", icon, variant = "danger", onConfirm, onCancel, onDismiss }) {
  const handleDismiss = onDismiss || onCancel;
  const variants = {
    danger: {
      iconBg: "bg-red-100",
      iconColor: "text-red-500",
      buttonBg: "bg-red-500 hover:bg-red-600",
    },
    info: {
      iconBg: "bg-blue-100",
      iconColor: "text-blue-500",
      buttonBg: "bg-blue-500 hover:bg-blue-600",
    },
    success: {
      iconBg: "bg-green-100",
      iconColor: "text-green-500",
      buttonBg: "bg-green-500 hover:bg-green-600",
    },
  };

  const v = variants[variant] || variants.danger;

  const defaultIcons = {
    danger: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
      </svg>
    ),
    info: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    success: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    ),
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={handleDismiss}>
      <div role="dialog" aria-modal="true" aria-label={title} className="bg-white dark:bg-gray-800 rounded-2xl max-w-sm w-full shadow-xl p-6 relative" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          aria-label="Close dialog"
          onClick={handleDismiss}
          className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:text-gray-300 dark:hover:bg-gray-700 transition"
        >
          &times;
        </button>
        <div className={`w-12 h-12 ${v.iconBg} rounded-full flex items-center justify-center mx-auto mb-4`}>
          <span className={v.iconColor}>
            {icon || defaultIcons[variant] || defaultIcons.danger}
          </span>
        </div>
        <h3 className="text-lg font-bold text-gray-800 dark:text-white text-center">{title}</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 text-center mt-2">{message}</p>
        <div className="flex space-x-3 mt-6">
          {cancelText && (
            <button
              onClick={onCancel}
              className="flex-1 py-2.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition"
            >
              {cancelText}
            </button>
          )}
          <button
            onClick={onConfirm}
            className={`flex-1 py-2.5 rounded-lg text-sm font-medium text-white ${v.buttonBg} transition`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
